package com.patronat.top.ui.models

data class WorkScheduleDay(
    val id: String,
    val label: String,
    val isOpen: Boolean,
    val openTime: String,
    val closeTime: String
)
